import { GridLayout } from '@nilohealth/core-ui'
import { DashboardLayoutBackground, DashboardLayoutContainer } from './dashboard.styles'

interface DashboardLayoutProps {
  children: React.ReactNode
}
const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  return (
    <DashboardLayoutContainer>
      <DashboardLayoutBackground />

      <GridLayout css={{ zIndex: '$zIndex100' }}>{children}</GridLayout>
    </DashboardLayoutContainer>
  )
}

export default DashboardLayout
